import { createSlice } from '@reduxjs/toolkit';




import { MANAGE_EMPLOYEE_CYCLES } from '../../actions/ManageEmployeeCycle/ManageEmployeeCycleAcionType';


const initialState = {
  manageEmployeeCycle: {
    isLoading: false,
        
    EmployeeCycles: [],
 
    data:null,
    errors: '',
    message: ''
  }
};

export const manageEmployeeCyclesSlice = createSlice({
  name: MANAGE_EMPLOYEE_CYCLES,
  initialState,
  reducers: {
    getManageEmployeeCycleAction: (state) => {
      state.manageEmployeeCycle.isLoading = true;
      state.manageEmployeeCycle.errors = '';
    },
    getManageEmployeeCyclesSuccessAction: (state, action) => {

      if (action.payload) {
        state.manageEmployeeCycle.EmployeeCycles = action.payload;
      
      }
      state.manageEmployeeCycle.isLoading = false;
    },
    getManageEmployeeCyclesFailureAction: (state, action) => {
      // state.user.isLoading = false;
      state.manageEmployeeCycle.isLoading = false;
      state.manageEmployeeCycle.errors = action.payload;
    },
 
 
   
  }
});

export const {
    getManageEmployeeCycleAction,
    getManageEmployeeCyclesSuccessAction,
    getManageEmployeeCyclesFailureAction,
    

} = manageEmployeeCyclesSlice.actions;

export default manageEmployeeCyclesSlice.reducer;
      